import moment from 'moment';
import { Investment_IdeaType } from 'types/common';
import { Investment_BuyOrderStatus } from '../../../../../../__generated__/globalTypes';
import { OrderType } from '../../../types';
import { getLaterDate } from '../utils';
import { OrderStatusContentFragment } from './__generated__/OrderStatusContentFragment';

import './index.scss';

type Order = OrderStatusContentFragment;

export const getStartDate = (order: Order): string | null => {
  if (order.__typename === OrderType.Idea) {
    const { status, startDate, lockDate, product } = order;

    if (!product) {
      return null;
    }

    const { ideaType } = product;

    if (
      (ideaType === Investment_IdeaType.LIMITED || ideaType === Investment_IdeaType.UNLIMITED) &&
      [
        Investment_BuyOrderStatus.ACCEPTED,
        Investment_BuyOrderStatus.LOCKED,
        Investment_BuyOrderStatus.SEALED,
        Investment_BuyOrderStatus.POSTPONED,
        Investment_BuyOrderStatus.CREATED,
        Investment_BuyOrderStatus.PREPARED_TO_CANCEL,
      ].includes(status)
    ) {
      return startDate && moment(startDate).format('D MMMM');
    }

    if (
      ideaType === Investment_IdeaType.BUY_AND_HOLD &&
      [
        Investment_BuyOrderStatus.CREATED,
        Investment_BuyOrderStatus.ACCEPTED,
        Investment_BuyOrderStatus.LOCKED,
      ].includes(status)
    ) {
      const laterDate = getLaterDate(startDate, lockDate);
      return laterDate && `≈${moment(laterDate).format('D MMMM')}`;
    }
  }

  if (order.__typename === OrderType.Stock) {
    return moment(order.auditInfo.createdAt).format('D MMMM');
  }

  return null;
};
